export default function authHeader(user) {
    /*
    Helper function to add JWT required header for requests
    */
    let token;
    if (user?.userData?.token) {
        token = user.userData.token;
    } else {
        token = null;
    }
    const request_options = {
        headers: {
            Authorization: `JWT ${token}`,
        },
    };
    return request_options;
}
